import React, { useEffect, useState, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import MUIDataTable from 'mui-datatables';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';

const FeedbackSmsReport = ({ openReport, dateFrom, dateTo, selectedRegionIds, changeRegionIds, reportUrl }) => {

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    const userDetails = JSON.parse(localStorage.getItem('user_details'));

    const [allReports, setAllReports] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const timeoutRef = useRef(null);

    const columns = [
        {
            label: 'Branch',
            name: 'branchName',
            options: { sort: true, filter: false }
        },
        {
            label: 'Sent Date',
            name: 'sentDate',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => (
                    <p style={{ margin: 0, width: '100px' }}>{value}</p>
                )
            }
        },
        {
            label: 'Sent Time',
            name: 'sentTime',
            options: { sort: true, filter: false }
        },
        {
            label: 'Number',
            name: 'number',
            options: { sort: true, filter: false }
        },
        {
            label: 'Message',
            name: 'message',
            options: { sort: false, filter: false }
        },
        {
            label: 'Response',
            name: 'response',
            options: { sort: false, filter: false }
        },
        {
            label: 'Kiosk',
            name: 'kiosk',
            options: { sort: true, filter: false }
        },
        {
            label: 'Status',
            name: 'status',
            options: { sort: true, filter: false }
        }
    ];

    const options = {
        viewColumns: false,
        filterType: 'dropdown',
        filter: false,
        responsive: 'vertical',
        serverSide: true,
        count: count,
        download: false,
        jumpToPage: true,
        selectableRows: 'none',
        print: false,
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: [10, 20, 30, 50, 100],
        setTableProps: () => ({ size: 'small' }),
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    getReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    break;
                case 'sort':
                    getReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    break;
                case 'changeRowsPerPage':
                    setRowsPerPage(tableState.rowsPerPage);
                    getReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    break;
                case 'search':
                    if (timeoutRef.current) clearTimeout(timeoutRef.current);
                    timeoutRef.current = setTimeout(() =>
                        getReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage), 2000);
                    break;
                default:
                    break;
            }
        }
    };

    useEffect(() => {
        if (openReport && dateFrom.length > 0 && dateTo.length > 0) {
            getReport(0, null, null, rowsPerPage);
        }
    }, [openReport, dateFrom, dateTo]);

    useEffect(() => {
        if (openReport) {
            getReport(0, null, null, rowsPerPage);
        }
    }, [changeRegionIds]);

    const getReport = (page, sortOrder, search, size) => {
        setIsLoading(true);

        axios({
            method: 'POST',
            url: `${reportUrl}/report-controller/feedback-sms-report`,
            headers: { Authorization: token },
            data: {
                page,
                size,
                dateFrom,
                dateTo,
                sort: sortOrder,
                searchText: search,
                branchIds: selectedRegionIds
            }
        }).then((res) => {
            const data = res.data.data;
            setAllReports(data.content);
            setCount(data.totalElements);
            setIsLoading(false);
        }).catch((error) => {
            console.log(error);
            setIsLoading(false);
            if (error.response !== undefined) {
                toast.error(error.response.data.message, { position: 'bottom-center' });
            } else {
                toast.remove();
                toast.error('Something went wrong', { position: 'bottom-center' });
            }
        });
    };

    return (
        <>
            <div><ToastContainer /></div>
            <MUIDataTable
                title={
                    isLoading
                        ? <CircularProgress color="secondary" size={20} />
                        : <>{count} records.</>
                }
                data={allReports}
                columns={columns}
                options={options}
                className="text-center-table"
            />
        </>
    );
};

export default FeedbackSmsReport;
